import React, { useState } from 'react';
import './StockFatherPage.css';

function StockFatherPage() {
  const [copySuccess, setCopySuccess] = useState('');
  const termsLastUpdated = 'October 9, 2026';

  const tradingViewCode = `//@version=5
indicator("D Byron", overlay=true, max_labels_count=300, max_lines_count=30)
// Intended for intraday charts. Entries and tracked exits confirm at bar close.
if not timeframe.isintraday
    runtime.error("Use an intraday chart for session VWAP and the daily/weekly magnet.")
// === INPUTS ===
// --- Group: Technical Indicators ---
group_tech = "Technicals: MAs & VWAP"
maFastLength = input.int(20, "Fast MA Length", minval=1, group=group_tech)
maSlowLength = input.int(50, "Slow MA Length", minval=1, group=group_tech)
// --- Group: Breakout / pullback continuation ---
group_cont = "Continuation: Range, VWAP & LazyBear"
enableContinuation = input.bool(true, "Enable Pullback / Bounce Setups", group=group_cont)
requirePriorTargetExit = input.bool(true, "Continuation Requires Previous Target Exit", tooltip="On preserves the original re-entry restriction. Off allows a qualifying breakout/pullback to be the first entry.", group=group_cont)
rearmAfterPullback = input.bool(true, "Allow Fresh Pullback Triggers After Exit", group=group_cont)
rangeSource = input.string("Chart rolling range", "Range Source", options=["Chart rolling range", "Previous RTH day"], tooltip="Previous RTH day keeps the prior completed regular-session high/low while signals use the chart's live candles. Use an ETH chart to include premarket signals.", group=group_cont)
rangeBars = input.int(14, "Chart Range Lookback (Bars)", minval=2, group=group_cont)
continuationMaxBars = input.int(30, "Maximum Bars After Breakout", minval=3, maxval=200, group=group_cont)
retestToleranceTicks = input.int(2, "Retest Tolerance (Ticks)", minval=0, group=group_cont)
usePullbackStop = input.bool(true, "Continuation: Also Protect Pullback Low/High", group=group_cont)
showContinuationLines = input.bool(false, "Show Current Continuation Levels", group=group_cont)
lbLength = input.int(20, "LazyBear Momentum Length (Match Your Tool)", minval=2, group=group_cont)
// LazyBear's original momentum formula, adapted to Pine v5; not volume.
// Author source: https://www.tradingview.com/script/nqQ1DT5a-Squeeze-Momentum-Indicator-LazyBear/
// No requirement for a squeeze release: only the bright histogram state.
lbMid = math.avg(math.avg(ta.highest(high, lbLength), ta.lowest(low, lbLength)), ta.sma(close, lbLength))
lbMomentum = ta.linreg(close - lbMid, lbLength, 0)
lbBullSharp = not na(lbMomentum[1]) and lbMomentum > 0 and lbMomentum > lbMomentum[1]
lbBearSharp = not na(lbMomentum[1]) and lbMomentum < 0 and lbMomentum < lbMomentum[1]
// --- Group: Institutional & Options Levels ---
group_levels = "Price Reference Levels"
// === Dynamic GEX + HVL (Proxies) ===
gex1_level = ta.highest(close, 10)
gex2_level = ta.lowest(close, 10)
gex3_level = (gex1_level + gex2_level) / 2
hvl_level = ta.vwap(hlc3)
// === Dynamic Resistance & Hybrid Levels ===
rthTicker = ticker.new(syminfo.prefix, syminfo.ticker, session.regular)
[rthPriorHigh, rthPriorLow] = request.security(rthTicker, "D", [high[1], low[1]], lookahead=barmerge.lookahead_on)
callResistance_level = rangeSource == "Previous RTH day" ? rthPriorHigh : ta.highest(high, rangeBars)
putResistance_level = rangeSource == "Previous RTH day" ? rthPriorLow : ta.lowest(low, rangeBars)
// === Dynamic Institutional & Options Levels ===
[twh_level, twl_level, weeklyOpenDisplay, twa_level] = request.security(syminfo.tickerid, "W", [high, low, open, hlc3])
[tdh_level, tdl_level] = request.security(syminfo.tickerid, "D", [high, low])
// Previous daily values are confirmed; current weekly OPEN is known at week start.
// Developing daily/weekly high, low and HLC3 above are display-only and can change.
[ydo_level, ydc_level] = request.security(syminfo.tickerid, "D", [open[1], close[1]], lookahead=barmerge.lookahead_on)
two_level = request.security(syminfo.tickerid, "W", open, lookahead=barmerge.lookahead_on)
// --- Group: Trade Management ---
group_trade_mgmt = "Trade Management (Based on Underlying's Price)"
stopLossPoints = input.float(0.75, "Stop Loss (Points)", minval=0.1, group=group_trade_mgmt)
useAtrBreakoutTarget = input.bool(true, "Use ATR Target When Price Breaks Past Range", tooltip="When there is no untouched range level ahead, use a fixed projected target. This is an ATR distance, not resistance/support.", group=group_trade_mgmt)
breakoutTargetAtr = input.float(2.0, "Breakout Target: Chart ATR Multiple", minval=0.1, group=group_trade_mgmt)
breakoutTargetMin = input.float(0.25, "Breakout Target: Minimum Points", minval=0.01, group=group_trade_mgmt)
// One policy controls both entry and exit behavior.
magnetPolicy = input.string("Block entries + exit inside", "YDC / Weekly Open Magnet Policy", options=["Block entries + exit inside", "Block entries only", "Warn only", "Exit on crossing inside"], tooltip="The zone is a price-reference band, not measured options liquidity. Warn only does not block or exit trades. Crossing mode exits only when a completed candle moves from outside to inside.", group=group_trade_mgmt)
preventTradeInMagnet = magnetPolicy == "Block entries + exit inside" or magnetPolicy == "Block entries only"
enableMagnetExit = magnetPolicy == "Block entries + exit inside" or magnetPolicy == "Exit on crossing inside"
// --- Group: Wide magnet behavior ---
group_magnet = "SPY: Wide Magnet Rules"
adaptWideMagnet = input.bool(true, "Enable Wide Magnet Rules", group=group_magnet)
wideMinPoints = input.float(1.50, "Wide Band: Minimum Width (SPY Points)", minval=0.01, group=group_magnet)
wideAtrMultiple = input.float(6.0, "Wide Band: Minimum Width / Chart ATR", minval=1, group=group_magnet)
magnetAtrLength = input.int(14, "Chart ATR Length", minval=1, group=group_magnet)
centerPercent = input.float(20, "Center No-Entry Zone (% of Band Width)", minval=1, maxval=80, group=group_magnet)
minMagnetRoomPoints = input.float(0.25, "Minimum Room to Next Band Boundary (Points)", minval=0.01, group=group_magnet)
minMagnetRoomAtr = input.float(1.5, "Minimum Room / Chart ATR", minval=0.1, group=group_magnet)
// These defaults are configurable starting rules, not optimized SPY settings.
// Warn-only policy remains unrestricted. Wide rules refine policies that block/exit.
// --- Group: Cross-Market Confirmation ---
group_crossmarket = "Cross-Market Confirmation"
es1_symbol = input.symbol("CME_MINI:ES1!", "E-mini S&P 500 Futures", group=group_crossmarket)
// MODIFICATION: Replaced IWF with QQQ for closer correlation to SPY/ES1
qqq_symbol = input.symbol("NASDAQ:QQQ", "Nasdaq 100 ETF (QQQ)", group=group_crossmarket)
vol_lookback = input.int(20, "Volume Lookback Period", minval=1, group=group_crossmarket)
// --- Group: Style & Visuals ---
group_style = "Style & Visuals"
showDiagnostics = input.bool(false, "Show Full Diagnostic Panel", group=group_style)
compactMarkers = input.bool(true, "Use Small Entry / Exit Markers", group=group_style)
historyScope = input.string("Today", "Trade Marker History", options=["Today", "All retained"], group=group_style)
show_chart_labels = input.bool(false, "Show Price Reference Labels", group=group_style)
filter_signals_by_volume = input.bool(false, "Filter Signals by Cross-Market Volume", group=group_style)
showExtendedReferences = input.bool(false, "Show Daily / Weekly Reference Labels", group=group_style)
labelOffset = input.int(8, "Level Label Offset (Bars)", minval=1, maxval=50, group=group_style)
historyLabels = input.int(30, "Trade History Markers to Keep", minval=2, maxval=240, group=group_style)
showTargetHitMarkers = input.bool(false, "Show Historical Target Hit Markers", group=group_style)
showTargetLine = input.bool(true, "Show Target Line Across Chart", group=group_style)
keepLastTargetLine = input.bool(false, "Keep Most Recent Closed Target Line", group=group_style)
show_bias = input.bool(true, "Show Directional Bias & Entry Status", group=group_style)
show_ydc_two_zone = input.bool(false, "Show YDC / TWO Zone", group=group_style)
color_gex = input.color(color.new(color.purple, 75), "Rolling Close Levels Color", group=group_style)
color_hvl = input.color(color.new(color.yellow, 75), "VWAP Color", group=group_style)
color_call_res = input.color(color.new(color.orange, 75), "Call Resistance Color", group=group_style)
color_put_res = input.color(color.new(color.navy, 75), "Put Resistance Color", group=group_style)
color_htf = color.new(color.gray, 30)
// === LINE AND LABEL MANAGEMENT ===
var all_lines = array.new<line>()
var all_labels = array.new<label>()
var tradeLabels = array.new<label>()
// Only one target line is retained; it does not share the reference cleanup arrays.
var line tradeTargetLine = na
var float lastTargetPrice = na
var string lastTargetStatus = ""
pruneTradeLabels() =>
    while array.size(tradeLabels) > historyLabels
        label.delete(array.shift(tradeLabels))
drawLevel(price, label_txt, line_color, text_color) =>
    new_line = line.new(bar_index, price, bar_index - 1, price, extend=extend.left, color=line_color, style=line.style_solid, width=1)
    array.push(all_lines, new_line)
    label_text_to_show = label_txt + " " + str.tostring(price, format.mintick)
    new_label = label.new(bar_index + labelOffset + array.size(all_labels) % 3 * 5, price, text=label_text_to_show, style=label.style_label_left, xloc=xloc.bar_index, color=color.new(line_color, 0), textcolor=text_color, size=size.small)
    array.push(all_labels, new_label)
drawLabelOnly(price, label_txt, label_color) =>
    label_text_to_show = label_txt + " " + str.tostring(price, format.mintick)
    new_label = label.new(bar_index + labelOffset + array.size(all_labels) % 3 * 5, price, text=label_text_to_show, style=label.style_label_left, xloc=xloc.bar_index, color=color.new(label_color, 0), textcolor=color.white, size=size.small)
    array.push(all_labels, new_label)
if barstate.islast
    for l in all_lines
        line.delete(l)
    for l in all_labels
        label.delete(l)
    array.clear(all_lines)
    array.clear(all_labels)
    if show_chart_labels
        drawLevel(gex1_level, "Close High (10)", color_gex, color.white)
        drawLevel(gex2_level, "Close Low (10)", color_gex, color.white)
        drawLevel(gex3_level, "Close Mid (10)", color_gex, color.white)
        drawLevel(hvl_level, "VWAP", color_hvl, color.black)
        drawLevel(callResistance_level, "Call Resistance", color_call_res, color.white)
        drawLevel(putResistance_level, "Put Resistance", color_put_res, color.white)
        if showExtendedReferences
            drawLabelOnly(twh_level, "TWH", color_htf)
            drawLabelOnly(tdh_level, "TDH", color_htf)
            drawLabelOnly(twa_level, "Week HLC3 (developing)", color_htf)
            drawLabelOnly(two_level, "TWO", color_htf)
            drawLabelOnly(ydc_level, "YDC", color_htf)
            drawLabelOnly(twl_level, "TWL", color_htf)
            drawLabelOnly(tdl_level, "TDL", color_htf)
            drawLabelOnly(ydo_level, "YDO", color_htf)
// === LIQUIDITY MAGNET & TRADE FILTERS ===
magnetTop = math.max(ydc_level, two_level)
magnetBottom = math.min(ydc_level, two_level)
magnetReady = not na(magnetBottom) and not na(magnetTop)
priceInMagnetZone = magnetReady and close >= magnetBottom and close <= magnetTop
magnetAtr = ta.atr(magnetAtrLength)
magnetWidth = magnetTop - magnetBottom
wideMagnet = adaptWideMagnet and magnetReady and not na(magnetAtr) and magnetWidth >= math.max(wideMinPoints, magnetAtr * wideAtrMultiple)
magnetMid = math.avg(magnetTop, magnetBottom)
centerLow = magnetMid - magnetWidth * centerPercent / 200.0
centerHigh = magnetMid + magnetWidth * centerPercent / 200.0
priceInMagnetCenter = priceInMagnetZone and close >= centerLow and close <= centerHigh
requiredMagnetRoom = math.max(minMagnetRoomPoints, magnetAtr * minMagnetRoomAtr)
// The next obstacle is the center zone when approaching it, otherwise the outer edge.
wideCallBoundary = close < centerLow ? centerLow : magnetTop
widePutBoundary = close > centerHigh ? centerHigh : magnetBottom
var box ydc_two_zone = na
if barstate.islast
    box.delete(ydc_two_zone)
    ydc_two_zone := na
    if show_ydc_two_zone and magnetReady
        ydc_two_zone := box.new(math.max(0, bar_index - 200), magnetTop, bar_index + 50, magnetBottom, bgcolor=color.new(color.gray, 90), border_color=na, text=wideMagnet ? "Wide Band: directional setups outside center" : "YDC / Weekly Open Band", text_size=size.small, text_color=color.silver)
// === TRADE SIGNALS & LABELS ===
maFast = ta.sma(close, maFastLength)
maSlow = ta.sma(close, maSlowLength)
vwap_val = ta.vwap
valid_ma_vwap = not na(maFast) and not na(maSlow) and not na(vwap_val)
es1_volume = request.security(es1_symbol, timeframe.period, volume, gaps=barmerge.gaps_on, ignore_invalid_symbol=true)
es1_avg_vol = ta.sma(es1_volume, vol_lookback)
// MODIFICATION: Changed variable names and logic to use QQQ
qqq_volume = request.security(qqq_symbol, timeframe.period, volume, gaps=barmerge.gaps_on, ignore_invalid_symbol=true)
qqq_avg_vol = ta.sma(qqq_volume, vol_lookback)
es1_vol_spike = not na(es1_volume) and not na(es1_avg_vol) and es1_volume > es1_avg_vol * 1.5
qqq_vol_spike = not na(qqq_volume) and not na(qqq_avg_vol) and qqq_volume > qqq_avg_vol * 1.5
// MODIFICATION: Updated volume filter to check for qqq_vol_spike
volume_filter = filter_signals_by_volume ? (es1_vol_spike or qqq_vol_spike) : true
buy_state = maFast > maSlow and close > vwap_val and volume_filter and valid_ma_vwap
sell_state = maFast < maSlow and close < vwap_val and volume_filter and valid_ma_vwap
// Preserve full entry setup, including the 20/50 SMA, VWAP and optional filters.
// Put the magnet inside eligibility BEFORE detecting its rising edge. A setup
// blocked in the zone can now enter when eligible, but only if still valid.
wideCallAllowed = wideMagnet and priceInMagnetZone and not priceInMagnetCenter and lbBullSharp and close > maFast and close > open and close > close[1] and wideCallBoundary - close >= requiredMagnetRoom
widePutAllowed = wideMagnet and priceInMagnetZone and not priceInMagnetCenter and lbBearSharp and close < maFast and close < open and close < close[1] and close - widePutBoundary >= requiredMagnetRoom
buyMagnetFilter = not preventTradeInMagnet or (magnetReady and (not priceInMagnetZone or wideCallAllowed))
sellMagnetFilter = not preventTradeInMagnet or (magnetReady and (not priceInMagnetZone or widePutAllowed))
tradeEntryFilter = buyMagnetFilter or sellMagnetFilter
magnetBlocksEntry = preventTradeInMagnet and priceInMagnetZone and not (wideCallAllowed or widePutAllowed)
buyEligible = buy_state and buyMagnetFilter
sellEligible = sell_state and sellMagnetFilter
buyEdge = buyEligible and not nz(buyEligible[1], false)
sellEdge = sellEligible and not nz(sellEligible[1], false)
var bool inLongTrade = false
var bool inShortTrade = false
var float stopLossLevel = na
var float targetLevel = na
var string targetKind = ""
var bool profitTargetHit = false
var int lastTradeBar = na
var label activeEntryLabel = na
var bool activeIsContinuation = false
// Freeze wide-band exit context for the lifetime of a trade, including overnight.
var bool tradeWideMagnet = false
var float tradeCenterLow = na
var float tradeCenterHigh = na
var float tradeMagnetBottom = na
var float tradeMagnetTop = na
// The chart's rolling resistance remains unchanged. Entry targets snapshot it.
priorCallResistance = rangeSource == "Previous RTH day" ? rthPriorHigh : ta.highest(high, rangeBars)[1]
priorPutResistance = rangeSource == "Previous RTH day" ? rthPriorLow : ta.lowest(low, rangeBars)[1]
// Preserve a new standard setup if an exit on its first bar delays entry.
// Cancel that pending setup as soon as any existing entry rule fails.
var bool pendingBaseBuy = false
var bool pendingBaseSell = false
if barstate.isconfirmed
    if not buyEligible or timeframe.change("D")
        pendingBaseBuy := false
    if not sellEligible or timeframe.change("D")
        pendingBaseSell := false
// Arm only from a pullback while flat; never repeat entries each eligible bar.
var bool bullPullbackArmed = false
var bool bearBounceArmed = false
if barstate.isconfirmed
    if timeframe.change("D") or not buyEligible or inLongTrade or inShortTrade
        bullPullbackArmed := false
    if timeframe.change("D") or not sellEligible or inLongTrade or inShortTrade
        bearBounceArmed := false
    if rearmAfterPullback and not inLongTrade and not inShortTrade
        if buyEligible and close < close[1]
            bullPullbackArmed := true
        if sellEligible and close > close[1]
            bearBounceArmed := true
freshBullRecovery = bullPullbackArmed and buyEligible and close > open and close > close[1] and lbBullSharp
freshBearRejection = bearBounceArmed and sellEligible and close < open and close < close[1] and lbBearSharp
baseBuyTrigger = buyEdge or pendingBaseBuy or freshBullRecovery
baseSellTrigger = sellEdge or pendingBaseSell or freshBearRejection
// One watcher follows the most recent break. 0=idle, 1=push, 2=pullback.
// Range references are retained separately for both directions until new day.
var int watchDirection = 0
var int watchPhase = 0
var int breakoutBar = na
var int pullbackBar = na
var float brokenLevel = na
var float pushExtreme = na
var float continuationTarget = na
var float pullbackExtreme = na
var float savedBullRange = na
var float savedBearRange = na
var string continuationStatus = "CONTINUATION: waiting for range break"
var float tradeStructureStop = na
var bool pullbackHeld = false
var float heldExtreme = na
// Optional continuation permission from a target exit in the same direction.
var int continuationPermit = 0
retestTolerance = retestToleranceTicks * syminfo.mintick
newTradingDay = timeframe.change("D")
bullBreak = barstate.isconfirmed and not na(priorCallResistance) and close > priorCallResistance
bearBreak = barstate.isconfirmed and not na(priorPutResistance) and close < priorPutResistance
bool contBuySignal = false
bool contSellSignal = false
bool stopEvent = false
bool magnetExitEvent = false
bool targetEvent = false
// Clean up yesterday's closed target with today's marker history.
if barstate.isconfirmed and newTradingDay and historyScope == "Today" and not inLongTrade and not inShortTrade
    line.delete(tradeTargetLine)
    tradeTargetLine := na
    lastTargetPrice := na
    lastTargetStatus := ""
// Keep today's markers by default. Preserve an open trade's entry across days.
if barstate.isconfirmed and newTradingDay and historyScope == "Today"
    if array.size(tradeLabels) > 0
        for i = array.size(tradeLabels) - 1 to 0
            oldLabel = array.get(tradeLabels, i)
            if na(activeEntryLabel) or oldLabel != activeEntryLabel
                label.delete(oldLabel)
                array.remove(tradeLabels, i)
// Manage a tracked trade before considering any new entry. All tracking is
// underlying-based; labels/alerts are not broker orders or option P&L.
if barstate.isconfirmed and (inLongTrade or inShortTrade) and bar_index > lastTradeBar
    stopTouched = inLongTrade ? low <= stopLossLevel : high >= stopLossLevel
    targetTouched = not na(targetLevel) and (inLongTrade ? high >= targetLevel : low <= targetLevel)
    narrowMagnetExit = priceInMagnetZone and (magnetPolicy != "Exit on crossing inside" or (magnetReady[1] and not priceInMagnetZone[1]))
    // A wide-band trade is allowed to travel within its lane. Exit on a confirmed
    // close into/across the center or loss of directional MA/VWAP support inside.
    insideTradeBand = close >= tradeMagnetBottom and close <= tradeMagnetTop
    centerThreat = (close[1] < tradeCenterLow and close >= tradeCenterLow) or (close[1] > tradeCenterHigh and close <= tradeCenterHigh)
    inTradeCenter = close >= tradeCenterLow and close <= tradeCenterHigh
    wideSupportLost = insideTradeBand and (inLongTrade ? close <= maFast or close <= vwap_val or maFast <= maSlow : close >= maFast or close >= vwap_val or maFast >= maSlow)
    // Reaching a wide-lane target at the center counts as TARGET, not BAND.
    // A touched stop still wins when the candle also touches the target.
    magnetExitNow = enableMagnetExit and (tradeWideMagnet ? (inTradeCenter or centerThreat or wideSupportLost) and not targetTouched : narrowMagnetExit)
    if stopTouched or magnetExitNow or targetTouched
        wasLong = inLongTrade
        exitText = stopTouched ? (wasLong ? "EXIT CALL: stop" : "EXIT PUT: stop") : magnetExitNow ? "EXIT: magnet" : (wasLong ? "EXIT CALL: " + targetKind + " target" : "EXIT PUT: " + targetKind + " target")
        exitPrice = stopTouched ? stopLossLevel : magnetExitNow ? close : targetLevel
        markerExitText = compactMarkers ? (stopTouched ? "STOP" : magnetExitNow ? "BAND" : (wasLong ? "CALL HIT" : "PUT HIT")) : exitText
        // Completed targets are hidden by default so they cannot look like the next trade's target.
        if stopTouched or magnetExitNow or showTargetHitMarkers
            lbl = label.new(bar_index, exitPrice, markerExitText, color=stopTouched ? color.maroon : targetTouched and not magnetExitNow ? color.teal : color.gray, textcolor=color.white, style=wasLong ? label.style_label_down : label.style_label_up, size=compactMarkers ? size.tiny : size.small)
            label.set_tooltip(lbl, (wasLong ? "Closed CALL" : "Closed PUT") + ": " + exitText)
            array.push(tradeLabels, lbl)
            pruneTradeLabels()
        // Compact markers must also retire closed signals; active entries stay CALL/PUT.
        if not na(activeEntryLabel)
            label.set_text(activeEntryLabel, compactMarkers ? (wasLong ? "OLD CALL" : "OLD PUT") : (wasLong ? "OLD CALL (closed)" : "OLD PUT (closed)"))
            label.set_color(activeEntryLabel, color.new(color.gray, 35))
            label.set_tooltip(activeEntryLabel, exitText + " at " + str.tostring(exitPrice, format.mintick))
        if not na(tradeTargetLine)
            line.set_style(tradeTargetLine, line.style_dashed)
            line.set_color(tradeTargetLine, color.new(color.teal, 55))
            if not keepLastTargetLine
                line.delete(tradeTargetLine)
                tradeTargetLine := na
        lastTargetStatus := not stopTouched and not magnetExitNow and targetTouched ? "TARGET HIT " : "OLD TARGET "
        stopEvent := stopTouched
        magnetExitEvent := not stopTouched and magnetExitNow
        targetEvent := not stopTouched and not magnetExitEvent and targetTouched
        continuationPermit := targetEvent ? (wasLong ? 1 : -1) : 0
        if targetEvent
            continuationStatus := wasLong ? "CALL target hit: re-entry needs a new pullback setup" : "PUT target hit: re-entry needs a new bounce setup"
        activeEntryLabel := na
        inLongTrade := false
        inShortTrade := false
        stopLossLevel := na
        targetLevel := na
        tradeStructureStop := na
        profitTargetHit := targetEvent
if barstate.isconfirmed
    // VWAP's trading-day boundary also resets continuation context. It does
    // not silently close an existing tracked trade.
    if newTradingDay or not enableContinuation
        watchDirection := 0
        watchPhase := 0
        brokenLevel := na
        pushExtreme := na
        continuationTarget := na
        pullbackExtreme := na
        breakoutBar := na
        pullbackBar := na
        pullbackHeld := false
        heldExtreme := na
        continuationPermit := 0
        if newTradingDay
            savedBullRange := na
            savedBearRange := na
        continuationStatus := enableContinuation ? "CONTINUATION: waiting for range break" : "CONTINUATION: disabled"
    if enableContinuation
        // Do not replace the remembered level on every fresh high/low in the
        // same push. An opposite break starts a fresh, mirrored watcher.
        startBull = bullBreak and (watchDirection != 1 or watchPhase == 0)
        startBear = bearBreak and (watchDirection != -1 or watchPhase == 0)
        if startBull or startBear
            watchDirection := startBull ? 1 : -1
            watchPhase := 1
            breakoutBar := bar_index
            pullbackBar := na
            brokenLevel := startBull ? priorCallResistance : priorPutResistance
            pushExtreme := startBull ? high : low
            continuationTarget := na
            pullbackExtreme := na
            pullbackHeld := false
            heldExtreme := na
            if startBull
                savedBullRange := brokenLevel
            else
                savedBearRange := brokenLevel
            continuationStatus := startBull ? "CALL breakout: waiting for pullback" : "PUT breakdown: waiting for bounce"
        if watchPhase != 0 and bar_index > breakoutBar
            expired = bar_index - breakoutBar > continuationMaxBars
            structuralFailure = watchPhase == 2 and pullbackHeld and not na(heldExtreme) and (watchDirection == 1 ? close < heldExtreme : close > heldExtreme)
            // A return inside the old range alone is unresolved, not automatic
            // failure. A VWAP retest can still qualify after the range retest.
            if expired or structuralFailure
                continuationStatus := expired ? "CONTINUATION: expired; waiting for new break" : "CONTINUATION: pullback structure broken"
                watchPhase := 0
                watchDirection := 0
                brokenLevel := na
                continuationTarget := na
                pullbackExtreme := na
            else if watchPhase == 1
                beginsPullback = watchDirection == 1 ? (close < close[1] or low < low[1]) : (close > close[1] or high > high[1])
                if beginsPullback
                    watchPhase := 2
                    pullbackBar := bar_index
                    // Freeze the push's peak/trough BEFORE the pullback bar.
                    continuationTarget := pushExtreme
                    pullbackExtreme := watchDirection == 1 ? low : high
                    continuationStatus := watchDirection == 1 ? "CALL pullback: waiting" : "PUT bounce: waiting"
                else
                    pushExtreme := watchDirection == 1 ? math.max(pushExtreme, high) : math.min(pushExtreme, low)
                    continuationStatus := watchDirection == 1 ? "CALL push: no pullback yet" : "PUT push: no bounce yet"
            else if watchPhase == 2
                // A developing pullback can deepen before its first valid recovery.
                // Track the live extreme; heldExtreme separately preserves invalidation.
                pullbackExtreme := watchDirection == 1 ? math.min(pullbackExtreme, low) : math.max(pullbackExtreme, high)
        if watchPhase == 2
            isBullWatch = watchDirection == 1
            beyondRange = isBullWatch ? close > brokenLevel : close < brokenLevel
            rangeVWAPOrder = not na(vwap_val) and (isBullWatch ? vwap_val <= brokenLevel : vwap_val >= brokenLevel)
            rangeRetest = rangeVWAPOrder and beyondRange and (isBullWatch ? low <= brokenLevel + retestTolerance : high >= brokenLevel - retestTolerance)
            shallowHold = beyondRange and (isBullWatch ? low > brokenLevel + retestTolerance and close > vwap_val : high < brokenLevel - retestTolerance and close < vwap_val)
            vwapRetest = not na(vwap_val) and (isBullWatch ? low <= vwap_val + retestTolerance and close > vwap_val : high >= vwap_val - retestTolerance and close < vwap_val)
            recoveryCandle = bar_index > pullbackBar and (isBullWatch ? close > open and close > close[1] : close < open and close < close[1])
            momentumSupports = isBullWatch ? lbBullSharp : lbBearSharp
            supportHolds = rangeRetest or shallowHold or vwapRetest
            roomToTarget = isBullWatch ? continuationTarget > close + syminfo.mintick : continuationTarget < close - syminfo.mintick
            if recoveryCandle and supportHolds and not pullbackHeld
                pullbackHeld := true
                heldExtreme := pullbackExtreme
            priceMomentumReady = recoveryCandle and supportHolds and momentumSupports and roomToTarget
            // Same gate as a standard entry; momentum only adds a requirement.
            entryGate = isBullWatch ? buyEligible : sellEligible
            noTrackedTrade = not inLongTrade and not inShortTrade
            priorTargetExit = not requirePriorTargetExit or continuationPermit == watchDirection
            noExitThisBar = not stopEvent and not magnetExitEvent and not targetEvent
            if priceMomentumReady and entryGate and noTrackedTrade and noExitThisBar and priorTargetExit
                contBuySignal := isBullWatch
                contSellSignal := not isBullWatch
                continuationStatus := isBullWatch ? "CALL continuation entry" : "PUT continuation entry"
            else if priceMomentumReady
                continuationStatus := not priorTargetExit ? "CONTINUATION: requires prior target exit" : not (isBullWatch ? buyMagnetFilter : sellMagnetFilter) ? "CONTINUATION: magnet blocks entry" : not entryGate ? "CONTINUATION: MA/VWAP or filters block entry" : not noTrackedTrade ? "CONTINUATION: trade already tracked" : "CONTINUATION: wait after exit"
            else if not roomToTarget
                // Retire a continuation whose frozen target was reached before entry.
                // Leaving watchPhase active kept this old status visible indefinitely.
                continuationStatus := isBullWatch ? "CALL target reached: waiting for new breakout" : "PUT target reached: waiting for new breakdown"
                watchPhase := 0
                watchDirection := 0
                brokenLevel := na
                continuationTarget := na
                pullbackExtreme := na
                pullbackHeld := false
                heldExtreme := na
            else if recoveryCandle and supportHolds and not momentumSupports
                continuationStatus := isBullWatch ? "CALL pullback holds: waiting bright green" : "PUT bounce holds: waiting bright red"
            else if not beyondRange and not vwapRetest
                continuationStatus := "Inside range: continuation unresolved"
            else
                continuationStatus := isBullWatch ? "CALL pullback: waiting for recovery" : "PUT bounce: waiting for rejection"
// A continuation is an early recovery entry toward the frozen recent extreme;
// it does not require a second breakout above/below that target first.
// Standard entries use an eligibility edge or a fresh armed pullback recovery.
// Avoid new entries on a bar that just triggered an exit (unknown OHLC order).
if barstate.isconfirmed and (stopEvent or magnetExitEvent or targetEvent)
    pendingBaseBuy := baseBuyTrigger and buyEligible
    pendingBaseSell := baseSellTrigger and sellEligible
baseBuySignal = barstate.isconfirmed and baseBuyTrigger and not inLongTrade and not inShortTrade
baseSellSignal = barstate.isconfirmed and baseSellTrigger and not inLongTrade and not inShortTrade
buy_condition = barstate.isconfirmed and not stopEvent and not magnetExitEvent and not targetEvent and (contBuySignal or baseBuySignal)
sell_condition = barstate.isconfirmed and not stopEvent and not magnetExitEvent and not targetEvent and (contSellSignal or baseSellSignal)
if buy_condition or sell_condition
    bullPullbackArmed := false
    bearBounceArmed := false
    pendingBaseBuy := false
    pendingBaseSell := false
    inLongTrade := buy_condition
    inShortTrade := sell_condition
    activeIsContinuation := contBuySignal or contSellSignal
    continuationPermit := 0
    stopLossLevel := buy_condition ? close - stopLossPoints : close + stopLossPoints
    tradeStructureStop := activeIsContinuation and usePullbackStop ? (buy_condition ? heldExtreme - syminfo.mintick : heldExtreme + syminfo.mintick) : na
    if not na(tradeStructureStop)
        // Structure may tighten the configured stop, never widen its distance.
        stopLossLevel := buy_condition ? math.max(stopLossLevel, tradeStructureStop) : math.min(stopLossLevel, tradeStructureStop)
    targetLevel := activeIsContinuation ? continuationTarget : buy_condition ? (priorCallResistance > close ? priorCallResistance : na) : (priorPutResistance < close ? priorPutResistance : na)
    targetKind := activeIsContinuation ? "RETEST" : "RANGE"
    // A breakout may have no resistance/support ahead. Never draw an old target
    // behind entry; explicitly identify the projected ATR target instead.
    if na(targetLevel) and useAtrBreakoutTarget and not na(magnetAtr)
        projectedDistance = math.max(breakoutTargetMin, magnetAtr * breakoutTargetAtr)
        targetLevel := buy_condition ? close + projectedDistance : close - projectedDistance
        targetKind := "ATR"
    // Apply the wide lane boundary only to entries allowed by the adaptive rules.
    tradeWideMagnet := wideMagnet
    tradeCenterLow := centerLow
    tradeCenterHigh := centerHigh
    tradeMagnetBottom := magnetBottom
    tradeMagnetTop := magnetTop
    if preventTradeInMagnet and wideMagnet and priceInMagnetZone
        laneTarget = buy_condition ? wideCallBoundary : widePutBoundary
        laneLimitsTarget = na(targetLevel) or (buy_condition ? laneTarget <= targetLevel : laneTarget >= targetLevel)
        if laneLimitsTarget
            targetLevel := laneTarget
            targetKind := "BAND"
    line.delete(tradeTargetLine)
    tradeTargetLine := na
    lastTargetPrice := targetLevel
    lastTargetStatus := "TARGET "
    if showTargetLine and not na(targetLevel)
        tradeTargetLine := line.new(bar_index, targetLevel, bar_index + 1, targetLevel, extend=extend.both, color=buy_condition ? color.lime : color.red, width=2)
    profitTargetHit := false
    lastTradeBar := bar_index
    entryText = buy_condition ? (activeIsContinuation ? "CALL continuation" : "CALL entry") : (activeIsContinuation ? "PUT continuation" : "PUT entry")
    markerEntryText = compactMarkers ? (buy_condition ? "CALL" : "PUT") : entryText
    lbl = label.new(bar_index, buy_condition ? low : high, markerEntryText, color=buy_condition ? color.green : color.red, textcolor=color.white, style=buy_condition ? label.style_label_up : label.style_label_down, yloc=buy_condition ? yloc.belowbar : yloc.abovebar, size=compactMarkers ? size.tiny : size.small)
    array.push(tradeLabels, lbl)
    pruneTradeLabels()
    activeEntryLabel := lbl
    if activeIsContinuation
        // Consume once. Another re-entry requires a fresh break/pullback cycle.
        watchPhase := 0
        watchDirection := 0
        brokenLevel := na
        continuationTarget := na
        pullbackExtreme := na
        pullbackHeld := false
        heldExtreme := na
// Show only the current labeled references, matching the existing level style.
// The shared all_lines/all_labels arrays are cleared on each last-bar update.
// No historical step plots, duplicate VWAP plot, or colored price-axis tags.
if barstate.islast and showContinuationLines
    if not na(savedBullRange)
        drawLevel(savedBullRange, "CALL Range Retest", color.orange, color.white)
    if not na(savedBearRange)
        drawLevel(savedBearRange, "PUT Range Retest", color.aqua, color.black)
    // VWAP is labeled once when chart levels are enabled.
    if not show_chart_labels and not na(vwap_val)
        drawLevel(vwap_val, "VWAP Retest", color.yellow, color.black)
    if watchPhase == 2 and not na(pullbackExtreme)
        drawLevel(pullbackExtreme, watchDirection == 1 ? "Pullback Low" : "Bounce High", color.fuchsia, color.white)
    if watchPhase == 2 and pullbackHeld and not na(heldExtreme) and heldExtreme != pullbackExtreme
        drawLevel(heldExtreme, "Setup Invalidation", color.red, color.white)
    if watchPhase == 2 and not na(continuationTarget)
        drawLevel(continuationTarget, "Continuation Target", color.teal, color.white)
// Reuse the two floating labels instead of creating unmanaged labels each bar.
var label floatingStop = na
var label floatingTarget = na
if barstate.islast
    label.delete(floatingStop)
    label.delete(floatingTarget)
    floatingStop := na
    floatingTarget := na
    if showTargetLine and keepLastTargetLine and not inLongTrade and not inShortTrade and not na(tradeTargetLine) and not na(lastTargetPrice)
        floatingTarget := label.new(bar_index + labelOffset, lastTargetPrice, lastTargetStatus + str.tostring(lastTargetPrice, format.mintick), color=color.black, textcolor=color.new(color.teal, 30), style=label.style_label_left, size=size.tiny)
    if inLongTrade or inShortTrade
        txt = (inLongTrade ? "CALL Stoploss " : "PUT Stoploss ") + str.tostring(stopLossLevel, format.mintick)
        floatingStop := label.new(bar_index, stopLossLevel, txt, color=color.black, textcolor=color.red, style=label.style_label_right, size=size.tiny)
        if not profitTargetHit and not na(targetLevel)
            targetColor = inLongTrade ? color.lime : color.red
            // Reconcile on the last bar as well, so every displayed active target has its line.
            if showTargetLine
                if na(tradeTargetLine)
                    tradeTargetLine := line.new(bar_index, targetLevel, bar_index + 1, targetLevel, extend=extend.both, color=targetColor, width=2)
                line.set_y1(tradeTargetLine, targetLevel)
                line.set_y2(tradeTargetLine, targetLevel)
                line.set_extend(tradeTargetLine, extend.both)
            targetText = (inLongTrade ? "CALL TARGET (" : "PUT TARGET (") + targetKind + ") " + str.tostring(targetLevel, format.mintick)
            floatingTarget := label.new(bar_index + labelOffset, targetLevel, targetText, color=color.black, textcolor=targetColor, style=label.style_label_left, size=size.small)
        else
            floatingTarget := label.new(bar_index + labelOffset, close, inLongTrade ? "CALL: NO TARGET AHEAD" : "PUT: NO TARGET AHEAD", color=color.black, textcolor=color.silver, style=label.style_label_left, size=size.tiny)
// Bias is price pressure relative to the fast SMA and VWAP. It deliberately
// does not require the slow SMA or entry filters. This is NOT an entry signal.
biasReady = not na(maFast) and not na(vwap_val)
rawBias = biasReady ? (close > maFast and close > vwap_val ? 1 : close < maFast and close < vwap_val ? -1 : 0) : 0
var int confirmedBias = 0
biasBullShift = barstate.isconfirmed and biasReady and rawBias == 1 and confirmedBias != 1
biasBearShift = barstate.isconfirmed and biasReady and rawBias == -1 and confirmedBias != -1
if barstate.isconfirmed
    confirmedBias := rawBias
// Keep direction and entry status on the same last-completed-candle basis.
var string entrySummary = "NEW ENTRY: NONE - waiting for data"
if barstate.isconfirmed
    entrySummary := buy_condition ? (contBuySignal ? "CALL ENTRY: continuation confirmed" : "CALL ENTRY: confirmed") : sell_condition ? (contSellSignal ? "PUT ENTRY: continuation confirmed" : "PUT ENTRY: confirmed") : (inLongTrade or inShortTrade) ? (inLongTrade ? "CALL TRADE: already tracked" : "PUT TRADE: already tracked") : stopEvent or magnetExitEvent or targetEvent ? "NO ENTRY: exit this candle; wait for a fresh setup" : not valid_ma_vwap ? "NO ENTRY: waiting for MA/VWAP data" : preventTradeInMagnet and not magnetReady ? "NO ENTRY: magnet data unavailable" : magnetBlocksEntry ? (wideMagnet ? (priceInMagnetCenter ? "NO ENTRY: wide magnet center" : "NO ENTRY: wide band needs momentum / room") : "NO ENTRY: magnet policy blocks entry") : not volume_filter ? "NO ENTRY: cross-market volume filter" : maFast == maSlow ? "NO ENTRY: fast / slow MA equal" : maFast > maSlow and close <= vwap_val ? "CALL BLOCKED: price must close above VWAP" : maFast < maSlow and close >= vwap_val ? "PUT BLOCKED: price must close below VWAP" : rawBias == 1 and maFast < maSlow ? "CALL BIAS: fast MA remains below slow MA" : rawBias == -1 and maFast > maSlow ? "PUT BIAS: fast MA remains above slow MA" : buyEligible ? "CALL READY: waiting for fresh trigger" : sellEligible ? "PUT READY: waiting for fresh trigger" : "NO ENTRY: MA / VWAP alignment mixed"
    if not preventTradeInMagnet and priceInMagnetZone
        entrySummary := entrySummary + " | Inside YDC / Weekly Open band (entries allowed)"
var string shortStatus = "WAIT: DATA"
if barstate.isconfirmed
    shortStatus := buy_condition ? "CALL ENTRY" : sell_condition ? "PUT ENTRY" : inLongTrade ? "CALL ACTIVE" : inShortTrade ? "PUT ACTIVE" : stopEvent ? "EXIT: STOP" : magnetExitEvent ? "EXIT: BAND" : targetEvent ? "EXIT: TARGET" : not valid_ma_vwap ? "WAIT: DATA" : preventTradeInMagnet and not magnetReady ? "WAIT: BAND DATA" : magnetBlocksEntry ? (wideMagnet ? (priceInMagnetCenter ? "NO ENTRY: CENTER" : "WAIT: BAND SETUP") : "NO ENTRY: MAGNET") : not volume_filter ? "WAIT: VOLUME" : buyEligible ? (priceInMagnetZone and wideMagnet ? "CALL: WIDE BAND READY" : "CALL: WAIT FOR TRIGGER") : sellEligible ? (priceInMagnetZone and wideMagnet ? "PUT: WIDE BAND READY" : "PUT: WAIT FOR TRIGGER") : "WAIT: MA / VWAP"
var table biasPanel = table.new(position.middle_left, 1, 6, border_width=1)
if barstate.islast
    table.clear(biasPanel, 0, 0, 0, 5)
    if show_bias
        biasText = confirmedBias == 1 ? "DIRECTION: UP" : confirmedBias == -1 ? "DIRECTION: DOWN" : "DIRECTION: MIXED"
        biasColor = confirmedBias == 1 ? color.rgb(20, 100, 65) : confirmedBias == -1 ? color.rgb(140, 40, 40) : color.rgb(70, 70, 70)
        momentumWeakening = inLongTrade ? not na(lbMomentum[1]) and lbMomentum < lbMomentum[1] : inShortTrade ? not na(lbMomentum[1]) and lbMomentum > lbMomentum[1] : false
        tracked = inLongTrade ? "TRACKED TRADE: CALL" : inShortTrade ? "TRACKED TRADE: PUT" : "TRACKED TRADE: NONE"
        tracked := tracked + (momentumWeakening ? " - momentum weakening" : "")
        // Color the continuation row by the setup being watched, not the
        // independent price-bias header. Darker color means waiting/blocked.
        setupDirection = contBuySignal ? 1 : contSellSignal ? -1 : watchPhase != 0 ? watchDirection : 0
        setupTriggered = contBuySignal or contSellSignal
        setupColor = setupDirection == 1 ? (setupTriggered ? color.rgb(20, 130, 70) : color.rgb(25, 75, 45)) : setupDirection == -1 ? (setupTriggered ? color.rgb(170, 35, 35) : color.rgb(100, 35, 35)) : color.rgb(30, 30, 30)
        displayMomentum = barstate.isconfirmed ? lbMomentum : lbMomentum[1]
        displayPreviousMomentum = barstate.isconfirmed ? lbMomentum[1] : lbMomentum[2]
        momentumText = na(displayPreviousMomentum) ? "MOMENTUM: waiting for data" : displayMomentum > 0 ? (displayMomentum > displayPreviousMomentum ? "MOMENTUM: bullish, strengthening" : "MOMENTUM: bullish, fading / flat") : displayMomentum < 0 ? (displayMomentum < displayPreviousMomentum ? "MOMENTUM: bearish, strengthening" : "MOMENTUM: bearish, fading / flat") : "MOMENTUM: zero"
        contextText = "Range: " + rangeSource + (rangeSource == "Chart rolling range" ? " (" + str.tostring(rangeBars) + " bars)" : "") + " | Signals: chart " + timeframe.period + " | Magnet: " + magnetPolicy + (wideMagnet ? " (wide rules)" : " (standard rules)")
        if showDiagnostics
            table.cell(biasPanel, 0, 0, biasText + " | Last closed candle; not an entry", bgcolor=biasColor, text_color=color.white, text_size=size.normal)
            table.cell(biasPanel, 0, 1, entrySummary, bgcolor=color.rgb(30, 30, 30), text_color=color.white, text_size=size.normal)
            table.cell(biasPanel, 0, 2, continuationStatus, bgcolor=setupColor, text_color=color.white, text_size=size.normal)
            table.cell(biasPanel, 0, 3, tracked, bgcolor=color.rgb(30, 30, 30), text_color=color.white, text_size=size.normal)
            table.cell(biasPanel, 0, 4, momentumText, bgcolor=color.rgb(30, 30, 30), text_color=color.white, text_size=size.small)
            table.cell(biasPanel, 0, 5, contextText, bgcolor=color.rgb(30, 30, 30), text_color=color.white, text_size=size.small)
        else
            table.cell(biasPanel, 0, 0, biasText, bgcolor=biasColor, text_color=color.white, text_size=size.small)
            table.cell(biasPanel, 0, 1, shortStatus, bgcolor=color.rgb(30, 30, 30), text_color=color.white, text_size=size.small)
alertcondition(buy_condition, "CALL entry", "Confirmed CALL entry: MA/VWAP and enabled filters satisfied.")
alertcondition(sell_condition, "PUT entry", "Confirmed PUT entry: MA/VWAP and enabled filters satisfied.")
alertcondition(biasBullShift, "Bullish bias shift", "Bullish bias shift. This is not a CALL entry.")
alertcondition(biasBearShift, "Bearish bias shift", "Bearish bias shift. This is not a PUT entry.")
alertcondition(stopEvent, "Tracked stop touched", "Underlying touched the tracked stop on a completed bar.")
alertcondition(magnetExitEvent, "Tracked magnet exit", "Tracked position exited at the magnet on a completed bar.")
alertcondition(targetEvent, "Resistance / support target exit", "Tracked trade closed at its underlying resistance/support target on a completed bar.")
alertcondition(contBuySignal, "CALL continuation entry", "CALL continuation: pullback recovery + strengthening LazyBear momentum + all existing entry filters.")
alertcondition(contSellSignal, "PUT continuation entry", "PUT continuation: bounce rejection + strengthening LazyBear momentum + all existing entry filters.")`;

  const handleCopyCode = () => {
    navigator.clipboard.writeText(tradingViewCode).then(() => {
      setCopySuccess('Code copied to clipboard!');
      setTimeout(() => setCopySuccess(''), 3000);
    }, (err) => {
      setCopySuccess('Failed to copy code');
    });
  };

  return (
    <div className="stock-father-page">
      <h1>Tradingview Pinescript</h1>
      
      <section className="terms-of-agreement">
        <h2>TERMS OF AGREEMENT</h2>
        <p>Last Updated: {termsLastUpdated}</p>
        
        <ol>
          <li><strong>Acceptance of Terms:</strong> By accessing, using, or downloading any code or script ("Code") provided by D Byron aka Stock Father ("Provider") on TradingView.com, you agree to be bound by the terms outlined herein. If you do not agree, you must cease use immediately.</li>
          
          <li><strong>No Financial Advice:</strong> The Code is provided for informational and educational purposes only. It does not constitute financial, investment, trading, or any other form of professional advice. You acknowledge that trading involves substantial risk and you are solely responsible for any trading decisions based on the Code.</li>
          
          <li><strong>No Warranty & "As-Is" Provision:</strong> The Code is provided "as-is" without any warranty, express or implied. The Provider makes no representations regarding accuracy, completeness, reliability, or suitability for any particular purpose. Use at your own risk.</li>
          
          <li><strong>Limitation of Liability:</strong> To the fullest extent permitted by law, the Provider shall not be liable for any direct, indirect, incidental, consequential, or special damages, including but not limited to loss of profits, loss of data, trading losses, or any other damages arising out of the use or inability to use the Code, even if advised of the possibility of such damages.</li>
          
          <li><strong>User Responsibility & Assumption of Risk:</strong> You acknowledge that any use of the Code is at your own risk. The Provider shall not be responsible for any errors, miscalculations, or trading losses that may result from reliance on the Code.</li>
          
          <li><strong>No Guarantees of Performance:</strong> The Provider does not guarantee that the Code will yield profitable results or function without errors. Past performance does not indicate future results.</li>
          
          <li><strong>Compliance with Laws:</strong> Users are responsible for ensuring their compliance with all applicable laws, regulations, and broker policies when using the Code.</li>
          
          <li><strong>No Support or Updates:</strong> The Provider is under no obligation to provide support, updates, or modifications to the Code. The Code may be removed, altered, or discontinued at any time without notice.</li>
          
          <li><strong>Indemnification:</strong> You agree to indemnify and hold harmless the Provider from any claims, liabilities, damages, or expenses (including legal fees) arising from your use of the Code.</li>
          
          <li><strong>Modification of Terms:</strong> The Provider reserves the right to modify these Terms at any time. Continued use of the Code constitutes acceptance of any changes.</li>
          
          <li><strong>Governing Law & Dispute Resolution:</strong> These Terms shall be governed by and construed in accordance with the laws of the State of Missouri, United States. Any disputes shall be resolved exclusively in the courts of the State of Missouri, United States.</li>
          
          <li><strong>Contact Information:</strong> Use the contact form on this website.</li>
        </ol>
      </section>

      <section className="code-copy">
        <h2>Tradingview Pinescript</h2>
        <div className="code-container">
          <pre>{tradingViewCode}</pre>
          <button onClick={handleCopyCode} className="copy-button">
            Copy Code
          </button>
          {copySuccess && <p className="copy-success">{copySuccess}</p>}
        </div>
      </section>

      <section className="tradingview-walkthrough">
        <h2>How to Paste in TradingView Pine Editor</h2>
        <ol>
          <li>Open TradingView and navigate to the chart where you want to apply the strategy.</li>
          <li>Click the Pine Editor button on the right side of the chartÃ¢â‚¬â€the button looks like a triangular pinetree icon in the TradingView toolbar.</li>
          <li>If you have an existing script, click "New" to create a blank script.</li>
          <li>Delete any existing code in the editor.</li>
          <li>Paste the entire copied code into the Pine Editor.</li>
          <li>Click the "Add to Chart" button or press Ctrl+S (Cmd+S on Mac) to save and add the strategy.</li>
          <li>Adjust strategy settings in the "Settings" tab as needed.</li>
          <li>Enable/disable auto-trading and other parameters in the strategy inputs.</li>
        </ol>
        <p><strong>Note:</strong> Always backtest thoroughly and understand the strategy before using real funds. It is also recommended that you have ETH (Extended trading hours) open for the best indicator results. Also, this was designed for SPY so other tickers may have worse results.</p>
      </section>
    </div>
  );
}

export default StockFatherPage;




